"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Confirmation = void 0;
var _InnerPopupWrapperStyled = require("../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _Button = _interopRequireDefault(require("../../Button"));
var _popupSlice = require("../../../redux/popupSlice");
var _reactI18next = require("react-i18next");
var _store = require("../../../redux/store");
var _checkmarkBase = _interopRequireDefault(require("../../../assets/images/checkmarkBase"));
var _planHelper = require("../../../util/planHelper");
var _planDetailsSlice = require("../../../redux/planDetailsSlice");
var _jsxRuntime = require("react/jsx-runtime");
const Confirmation = () => {
  const offerDetails = (0, _store.useAppSelector)(_popupSlice.selectOfferData);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _checkmarkBase.default,
      alt: "checkmark icon"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
      children: t('unsubscribe-popup.success.title', 'Miss you already.')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.TextStyled, {
      children: [t('unsubscribe-popup.success.description', 'You have been successfully unsubscribed. Your current plan will expire on'), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.expiresAt) === _planHelper.INFINITE_DATE ? t('unsubscribe-popup.next-season-start', 'the next season start') : (0, _planHelper.dateFormat)(Number(offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.expiresAt))
      }), "."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      width: "auto",
      margin: "30px auto 0 auto",
      onClickFn: () => {
        dispatch((0, _popupSlice.hidePopup)());
        dispatch((0, _planDetailsSlice.updateList)());
      },
      children: t('unsubscribe-popup.back-button', 'Back to My Account')
    })]
  });
};

// eslint-disable-next-line import/prefer-default-export
exports.Confirmation = Confirmation;